import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FarmService} from '@services/farm.service';
import {LoaderService} from '@services/loader.service';
import {MortalityService} from '@services/mortality.service';
import {PlacementService} from '@services/placement.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-active-mortality',
    templateUrl: './active-mortality.component.html',
    styleUrl: './active-mortality.component.scss'
})
export class ActiveMrtalityComponent implements OnInit {
    @Input() placementId: number | null = null;
    selectedFarmId: number | null = null;
    @Output() close: EventEmitter<void> = new EventEmitter<void>();
    public mortalityForm: FormGroup;
    public farms: any = [];
    public farmhouses: any = [];
    public partitions: any = [];
    public isAuthLoading = false;
    public userDetail: any;
    public mortalities: any = [];
    public isLoading$: Observable<boolean>;
    @Output() dataSaved: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private fb: FormBuilder,
        private farmService: FarmService,
        private placementService: PlacementService,
        private toastr: ToastrService,
        private loaderService: LoaderService
    ) {
        this.isLoading$ = this.loaderService.isLoading$;
    }

    ngOnInit() {
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.mortalityForm = this.fb.group({
            PlacementId: this.placementId,
            farmHouseId: ['', Validators.required],
            typeId: ['', Validators.required],
            partitionId: ['',Validators.required],
            age: ['', [Validators.required, Validators.min(0)]],
            numberOfChicks: ['', [Validators.required, Validators.min(0)]],
            date: [this.formatDateTime(new Date()), Validators.required]
        });
        this.getFarmList(this.userDetail.id, this.placementId);
        this.getMortalityTypeList();
    }

    formatDateTime(date: Date): string {
        return date.toISOString().slice(0, 16);
    }
    onSave() {
        this.loaderService.showLoader();
        this.isAuthLoading = true;
        //this.markFormGroupTouched(this.parentForm);
        this.markFormGroupTouched(this.mortalityForm);
        if (this.mortalityForm.valid) {
            const mortalityData = this.mortalityForm.value;
            this.placementService
                .addActivePlacementMortality(mortalityData)
                .subscribe({
                    next: (response) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            this.toastr.success('Mortality Added Successfully');
                            this.dataSaved.emit();
                            this.close.emit();
                        }, 2000);
                    },
                    error: (error) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            // Handle login error
                            this.toastr.error(error.error);
                        }, 2000);
                    }
                });
        } else {
            this.loaderService.hideLoader();
            this.isAuthLoading = false;
            this.toastr.error('Please fill the required fields');
        }
    }
    getFarmList(userId: number, placementId?: number) {
        this.farmService
            .getFarmList(userId, placementId)
            .subscribe((result) => {
                this.farms = result;
                if (this.farms && this.farms.length > 0) {
                    this.selectedFarmId = this.farms[0].id;
                    if (this.selectedFarmId != null) {
                        this.getFarmHouseList(
                            this.selectedFarmId,
                            this.placementId
                        );
                    }
                } else {
                    this.selectedFarmId = null;
                    this.farmhouses = [];
                }
            });
    }
    getFarmHouseList(farmId: number, placementId?: number) {
        this.farmService
            .getFarmHouseList(farmId, placementId)
            .subscribe((result) => {
                this.farmhouses = result;
            });
    }
    getFarmHousePartitionList(farmHouseId: number, placementId?: number) {
        this.farmService
            .getFarmHousePartitionList(farmHouseId, placementId)
            .subscribe((result) => {
                this.partitions = result;
            });
    }
    getMortalityTypeList() {
        this.placementService.getMortalityTypeList().subscribe((result) => {
            this.mortalities = result;
        });
    }

    onFarmHouseChange(farmHouseId: number) {
        this.getFarmHousePartitionList(farmHouseId, this.placementId);
    }
    isControlInvalid(controlName: string): boolean {
        const control = this.mortalityForm.get(controlName);
        return control?.invalid && (control.touched || control.dirty);
    }
    private markFormGroupTouched(formGroup: FormGroup) {
        Object.values(formGroup.controls).forEach((control) => {
            control.markAsTouched();

            if (control instanceof FormGroup) {
                this.markFormGroupTouched(control);
            }
        });
    }
}
